type ResultType = SeasonDates;
type ApiResponseType = ApiSchema['OfferCollectionResponse'];
type ParamsType = ApiSchema['OfferCollectionRequest'];

/**
 * Loads "from - until" season dates for a specific activity (e.g. unlimited pass).
 * Based on actual available offers. Uses the first offer
 */
export default async function apiLoadActivitySeasonDates(
    activityId: string,
    passengerAge: number = 30,
    promotion?: Promotion,
): Promise<ApiResult<ResultType>> {
    try {
        return await callApiPost<ResultType, ApiResponseType, ParamsType>(
            '/offers',

            // Request body
            {
                offerSearchCriteria: {
                    activityIds: [
                        activityId,
                    ],
                },
                anonymousPassengerSpecifications: getAnonymousPassengerSpecifications(1, passengerAge, promotion),
                // only use general promo code here, otherwise send via passengerSpec
                ...(promotion && promotion.promotionType === 'GENERAL' && {
                    promotionCodes: [promotion],
                }),
            },

            (response: ApiResponseType) => {
                const offer = response.offers?.[0];

                if (!offer) {
                    throw new Error('No offers');
                }

                return {
                    dateFrom: zurichDay(offer?.activityOfferParts?.[0]?.validFrom),
                    dateUntil: zurichDay(offer?.activityOfferParts?.[0]?.validUntil),
                };
            },

        );
    }
    catch (error) {
        throw new Error('Failed to load activity season dates', { cause: error });
    }
}
